import styles from "./login_right.module.css";

const RightContent1 = () => {
  return (
    <div className={styles.rightContent}>
      <div>
        <div className={styles.subtractFrame}>
          <img className={styles.subtractIcon} alt="" src="/subtract1.svg"/>
          {/* <p className={styles.authnumberIcon}>AuthNumber</p> */}
          <img className={styles.authnumberIcon} alt="" src="/authnumber.svg" />
        </div>
        <div className={styles.headingText}>
          <h1 className={styles.heading}>Identity & Credentials Management Platform</h1>
          <div className={styles.supportingText}>
           {/* Securely Manage Identities and Credentials with Confidence */}
          </div>
        </div>
      </div>
      <img className={styles.vectorArrowIcon} alt="" src="/vector-arrow.svg" />
    </div>
  );
};

export default RightContent1;
